<template>
    <div class="flip">
        <div
            class="card"
            :class="{'card-flipped' : flipped }"
        >
            <div class="child-front">
                <div
                    class="btn-turn-around"
                    @click="flipped = true"
                >
                    <i class="icon-reply-all"></i>
                </div>
                <div class="card-content">
                    <h3>{{ child.firstname }}<br />{{ child.lastname }}</h3>

                    <div class="child-image">
                        <div
                            class="child-image-container"
                            :style="imageBackground"
                        ></div>
                    </div>

                    <kgr-tablet-view-child-medical-info
                        :medical-special-info="child.medicalSpecialInfo"
                        :drug-info="child.drugInfo"
                        :nutrition-info="child.nutritionInfo"
                        :medical-info="child.medicalInfo"
                    />
                </div>
                <div class="card-footer">
                    <a
                        class="btn btn-default btn-lg btn-block btn-raised btn-dontpress"
                        @click="flipped = !flipped"
                    >
                        {{ $t('child_checkin_but_enterMood') }}
                    </a>
                </div>
            </div>

            <div class="child-back">
                <img
                    :src="child.image"
                    class="child-image-small"
                />
                <div
                    class="btn-turn-around"
                    @click="flipped = !flipped"
                >
                    <i class="icon icon-reply-all rot180"></i>
                </div>
                <div class="card-content">
                    <div
                        class="moods-content"
                        :class="{'shifted': shifted}"
                    >
                        <div class="moods-content-side left">
                            <div class="mood">
                                <span>{{ $t('Allg. Befindlichkeit') }}</span>
                                <kgr-mood-picker
                                    v-model="child.mood.general_mood"
                                    edit-mode
                                />
                            </div>

                            <div class="mood">
                                <span>{{ $t('Essverhalten') }}</span>
                                <kgr-mood-picker
                                    v-model="child.mood.eating_behaviour"
                                    edit-mode
                                />
                            </div>

                            <div class="mood">
                                <span>{{ $t('Schlafverhalten') }}</span>
                                <kgr-mood-picker
                                    v-model="child.mood.sleeping_behaviour"
                                    edit-mode
                                />
                            </div>

                            <div class="mood">
                                <span>{{ $t('Stuhlgang') }}</span>
                                <kgr-mood-picker
                                    v-model="child.mood.bowel_movement"
                                    edit-mode
                                />
                            </div>

                            <div class="shift-link">
                                <span @click="shifted = !shifted">{{ $t('Bemerkung') }} >></span>
                            </div>
                        </div>
                        <div class="moods-content-side right">
                            <span>{{ $t('Bemerkung') }}</span>
                            <textarea
                                v-model="child.mood.comment"
                                class="mood-comment"
                            ></textarea>

                            <div class="shift-link">
                                <span @click="shifted = !shifted"><< {{ $t('Bewertungen') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <a
                        class="btn btn-default btn-lg btn-block btn-raised btn-press"
                        @click="updateMood()"
                    >
                        <span>{{ $t('Speichern') }}</span>

                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppTabletViewChildMedicalInfo from './TabletViewChildMedicalInfo';
import ChildMood from '../../js/dto/ChildMood';
import ChildMoodRepository from '../../js/repository/ChildMoodRepository';
import MoodPicker from '../child/mood-barometer/MoodPicker.vue';

export default {
    components: {
        'kgr-tablet-view-child-medical-info': AppTabletViewChildMedicalInfo,
        'kgr-mood-picker': MoodPicker,
    },
    props: {
        child: {
            type: Object,
            required: true,
        },
        errorCallback: {
            type: Function,
            required: true,
        }
    },
    data() {
        return {
            flipped: false,
            shifted: false,
            originalChild: null,
        }
    },
    computed: {
        imageBackground() {
            return 'background-image: url(' + this.child.image + ')';
        },
    },
    watch: {
        child: {
            immediate: true,
            handler: function (child) {
                this.originalChild = this.clone(child);
            },
        }
    },
    methods: {
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        updateMood() {
            this.flipped = false;

            ChildMoodRepository.update(this.child.id, ChildMood.fromData(this.child.mood))
                .catch(() => {
                    this.flipped = true;
                    this.errorCallback(this.originalChild);
                });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .child-image-small {
        padding: 0 !important;
        width: auto !important;
        max-height: 25px !important;
        height: 25px;
        position: absolute;
        top: 10px;
        left: 15px;
    }

    .child-back {
        overflow: hidden;
    }

    .shift-link {
        margin-top: 10px;
        color: #000;
        font-weight: var(--kgr-font-weight-bold);
        cursor: pointer;
    }

    .mood {
        line-height: 11px;
        margin-bottom: 5px;
    }

    .mood-comment {
        height: 172px;
        margin-top: 2px;
    }

    .moods-content {
        padding-top: 10px;
        width: 300px;
        transition: all 0.5s ease;

        &.shifted {
            transform: translateX(-160px);
        }
    }

    .moods-content-side {
        width: 140px;
    }

    .left {
        float: left;
    }

    .right {
        float: right;
    }

    .card-content .child-image {
        position: relative;
        min-width: 140px;
        border: 1px solid lightgrey;
    }
</style>
